var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrentPosition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66119 0.251593C0.989352 -0.33872 -0.060292 0.182303 0.00368694 1.07434L1.2434 18.3593L2.19504 18.6796L6.94312 12.9734L14.3589 12.6416L14.6792 11.69L1.66119 0.251593Z",
    fill: "#353A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentPosition);
export default __webpack_public_path__ + "static/media/currentPosition.fc045d6450f8001ba978e82e2473eb9c.svg";
export { ForwardRef as ReactComponent };